import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var deleteItemRes;
export const deleteItemTodo = createAsyncThunk('deleteItem', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sales_order_delete_item',
            data: {
                "id": data,
            },
            headers: { "Content-Type": "application/json" }
        })
        return deleteItemRes = res.data

    } catch (error) {
        return deleteItemRes = error.response.data
    }
})


